module.exports = () => {
  return {
    advertiser_id: {
      label: '广告主账户',
      type: 'select',
      props: {
        clearable: false,
        filterable: true,
      },
      options: [],
      value: '',
      rules: { required: true, trigger: ['change'], message: '请选择广告主账户' },
    },
    advertiser_source_id: {
      label: '模板来源',
      type: 'select',
      props: {
        clearable: false,
        filterable: true,
      },
      options: [],
      value: '',
      rules: { required: true, trigger: ['change'], message: '请选择模板来源' },
    },
    name: {
      label: '模板名称',
      type: 'input',
      props: {
        placeholder: '请输入模板名称',
        showWordLimit: true,
        maxlength: 50,
      },
      value: '',
      rules: { required: true, trigger: ['change'], message: '请输入模板名称' },
    },
  };
};
